<label class="text-standard" *ngIf="attachmentValues.length > 0" for="added-attachments">Tillagda bilagor</label>
<p *ngFor="let error of uploadErrors" class="error-text">{{error}}</p>
<app-table *ngIf="attachmentValues.length > 0" id="added-attachments">
    <thead>
        <tr>
            <td scope="col" style="width: 90%">Bilaga</td>
            <td scope="col"></td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let attachment of attachmentValues; let i = index">
            <td label="Bilaga">{{attachment.fileName}}</td>
            <td label="Ta bort">
                <button class="btn btn--secondary btn--small" (click)="deleteAttachment(i)"
                    [attr.aria-label]="'ta bort ' + attachment.fileName">
                    <svg focusable="false" class="skv-icon skv-icon--inline">
                        <use xlink:href="#material-icon-delete"></use>
                    </svg>
                </button>
            </td>
        </tr>
    </tbody>
</app-table>
<app-form-group>
    <input type="file" #fileInput hidden (change)="onFileSelect($event.target.files)" />
    <button class="btn btn--secondary" (click)="openFileExplorer()">Lägg till bilaga</button>
</app-form-group>